import { CircularProgress } from "@material-ui/core";
import React from "react";

export const LoadingIcon = () => {
    return <CircularProgress color="primary" size={100} thickness={5} />;
};

export default LoadingIcon;
